import { updateName as updateOpportunityName } from '../opportunity/api'
import { ENTITY_TYPES } from '@sales-center/common'
import { StoreData } from '../reducers/typings'
import {
  IOpportunity,
  selectOpportunityById,
  selectOpportunityDetail,
} from '../opportunity'

import { ILeadOppProduct } from './typings'
import { selectAllLeadOppProducts } from './slice'
import { createSystemOpportunityName } from '@user/components/Opportunities/OpportunityName/functions'

export function updateEntityNameByLocationId(
  entityType: ENTITY_TYPES,
  entityId: number | undefined,
  thunkApi,
  updateType: 'create' | 'delete' | 'update',
  serviceLocationId: number,
) {
  if (entityType === ENTITY_TYPES.Opportunity && entityId) {
    const state = thunkApi.getState() as StoreData
    const opportunity: IOpportunity | undefined = selectOpportunityById(
      state,
      entityId,
    )
    const opportunityDetail = selectOpportunityDetail(state)

    if (
      (opportunity && opportunity.useSystemName) ||
      (opportunityDetail && opportunityDetail.useSystemName)
    ) {
      const currentServices: ILeadOppProduct[] = selectAllLeadOppProducts(state)
      const locationProducts = currentServices?.filter(
        (row: ILeadOppProduct) =>
          row.serviceLocationId == serviceLocationId?.toString(),
      )

      let newServices: ILeadOppProduct[] = Object.assign([], currentServices)

      locationProducts.forEach((row: ILeadOppProduct) => {
        if (updateType == 'create') {
          newServices = Object.assign([], currentServices)
          newServices.push(row)
        }
        if (updateType == 'delete') {
          newServices = newServices.filter((x) => x.id !== row.id)
        }
        if (updateType == 'update') {
          newServices = newServices.map((obj) =>
            obj.id === row?.id && row ? row : obj,
          )
        }
      })

      if (newServices) {
        const newOppName: string = createSystemOpportunityName(newServices)
        const nameToCompare = opportunity
          ? opportunity.opportunityName
          : opportunityDetail?.opportunityName
        if (nameToCompare !== newOppName) {
          thunkApi.dispatch(
            updateOpportunityName({
              id: entityId,
              name: newOppName,
              useSystemName: true,
            }),
          )
        }
      }
    }
  }
}
